import React from "react";
import { Layout } from "../../layouts/Layout";

const TermsConditions = () => {
  return (
    <Layout title="Terms & Conditions">
      <div className="container pt-120 pb-100">
        <div className="blog-details-content">
          <h2 className="title">Terms and Conditions</h2>
          <p>
            These Terms govern all interactions between the Customer and Kadle
            Global Pvt Ltd across all purchase channels. By accessing, browsing,
            or buying through our website or affiliates, you acknowledge full
            understanding and acceptance of these terms.
          </p>
          <ol>
            <li>
              <h5>Product & Service Representation</h5>
              <p>
                Images and descriptions are for reference only. Actual product
                color, size, or packaging may differ due to natural variations
                or supplier availability.
              </p>
              <p>
                All information is provided in good faith; however, the Company
                does not guarantee completeness or accuracy of any external
                content.
              </p>
            </li>
            <li>
              <h5>Orders & Pricing</h5>
              <p>All orders are final once confirmed.</p>
              <p>
                Prices may change without prior notice due to market or supply
                variations.
              </p>
              <p>
                The Company reserves the right to cancel or modify orders due to
                typographical errors, stock unavailability, or regulatory
                issues.
              </p>
            </li>
            <li>
              <h5>Intellectual Property</h5>
              <p>
                All content, trademarks, product names, and digital materials on
                <span className="mx-2 text-lowercase">
                  <a
                    href="https://kadleglobal.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://kadleglobal.com
                  </a>
                </span>
                are the sole property of Kadle Global Pvt Ltd. Unauthorized use,
                reproduction, or redistribution of this material is strictly
                prohibited.
              </p>
            </li>
            <li>
              <h5>Limitation of Liablity</h5>
              <p>
                Kadle Global Pvt Ltd, its directors, employees, or affiliates
                shall not be held liable for:
                <ul>
                  <li>
                    Any indirect, consequential, or incidental damages resulting
                    from product use.
                  </li>
                  <li>
                    Loss of data, reputation, or revenue due to third-party
                    actions, courier delays, or technical issues.
                  </li>
                  <li>
                    Misuse, misinterpretation, or unauthorized resale of our
                    products.
                  </li>
                </ul>
              </p>
            </li>
            <li>
              <h5>Reputation & Defamation Protection</h5>
              <p>
                The Company operates under lawful and ethical standards. Any
                false public statement, online defamation, slander, or
                misleading representation that harms or intends to harm the
                reputation of Kadle Global Pvt Ltd or its management will be
                treated as a legal offense, and may invite civil or criminal
                proceedings under applicable laws.
              </p>
            </li>
            <li>
              <h5>Dispute Resolution</h5>
              <p>
                All disputes shall be governed by the laws of India, and subject
                exclusively to the jurisdiction of the courts in Karnataka.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </Layout>
  );
};

export default TermsConditions;
